export function getChannel(): JQuery | null {
    let self: ExtendedWindow = window.parent;

    try {
        // try to access parent window property to check for cross-origin frame
        getLocationHost(self);
    } catch {
        self = window;
    }

    if (!self.$) {
        return null;
    }

    let channel: JQuery = self.$(document);
    if (self.Granite?.author) {
        // is set only in touchui
        channel = self.$(self.document);
    }

    return channel;
}

const getLocationHost = (self: Window) => {
    return self.location.host;
};

declare global {
    interface Window {
        Granite?: {
            author?: {
                ContentFrame?: {
                    contentWindow?: {
                        document?: Document;
                    };
                };
            };
        };
    }
}

type ExtendedWindow = Window & {
    $?: JQueryStatic;
};
